<style lang="scss">
@media screen and (min-width: 55rem) {
  .brand-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;

    .brand {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      height: auto;
      .brand-img {
        width: 60%;
        .brand-img-content {
          width: 100%;
          height: 0;
          padding: 0;
          // border-radius: 1rem;
          padding-bottom: 75%;
          background-size: cover;
          background-image: url("/media/yintai/homepage-1.jpg");
          background-repeat: no-repeat;
          background-position: 50%;
        }
        min-height: 20rem;
      }
      .brand-text {
        width: 40%;
        margin-left: 3rem;
        min-height: 10rem;
        margin-top: 3rem;
        .brand-title {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-size: 2.6rem;
          line-height: 1.4em;
          margin-top: 1rem;
          font-weight: 500;
        }
        .brand-introduction {
          font-size: 1.5rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          margin-top: 0.8rem;
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .brand-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;

    .brand {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: auto;
      .brand-img {
        width: 100%;
        .brand-img-content {
          width: 100%;
          height: 0;
          padding: 0;
          // border-radius: 1rem;
          padding-bottom: 75%;
          background-size: cover;
          background-image: url("/media/yintai/homepage-1.jpg");
          background-repeat: no-repeat;
          background-position: 50%;
        }
        min-height: 20rem;
      }
      .brand-text {
        width: 100%;
        min-height: 10rem;
        margin-top: 3rem;
        .brand-title {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-size: 2.6rem;
          line-height: 1.4em;
          margin-top: 1rem;
          font-weight: 500;
        }
        .brand-introduction {
          font-size: 1.5rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          margin-top: 0.8rem;
        }
      }
    }
  }
}
</style>

<template>
  <div class="brand-container">
    <div class="brand">
      <div class="brand-img"><div class="brand-img-content"></div></div>
      <div class="brand-text">
        <div class="brand-title">银泰概况</div>
        <div class="brand-introduction">里程碑大事件，银泰新闻</div>
        <a href="/about"><ButtonRed style="margin-top: 2rem"></ButtonRed></a>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonRed from "@/yintai/view/component/ButtonRed";

export default {
  name: "brand",
  components: { ButtonRed },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
